<template>
    <v-container class="mb-10">
        <v-row no-gutters>
            <v-col class="pa-0">
                <div>
                    <v-row>
                        <v-col class="d-flex justify-end">
                            <zoezi-autocomplete
                                v-model="search"
                                :items="filteredTeamsports"
                                :search-input.sync="searchText"
                                :label="searchLabel"
                                item-text="name"
                                item-value="name"
                                return-object
                                prepend-inner-icon="mdi-magnify"
                                style="max-width: 200px"
                            ></zoezi-autocomplete>
                        </v-col>
                    </v-row>
                </div>
                <v-divider></v-divider>
                <div v-if="loading" class="d-flex align-center justify-center">
                    <v-progress-circular size="20" indeterminate color="primary" width="2"></v-progress-circular>
                </div>
                <div v-else>
                    <CardLayout v-if="teamsports" :items="filteredTeamsports" v-slot="{item: category, layout}">
                        <CategoryCard
                            :category="category"
                            :defaultImageKey="imageUrl"
                            :title-right="layout == 'wide'"
                            @click="gotoCompetitionList(category)"
                            :to="link + '/' + category.id"
                        />
                    </CardLayout>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import CardLayout from './CardLayout.vue'
import CategoryCard from './CategoryCard.vue'
import ZoeziAutocomplete from '../components/ui/form/Autocomplete.vue';

export default {
    name: 'zoezi-teamsport-category-list',

    zoezi: {
        title: 'Categories for competitions',
        icon: 'mdi-trophy',
        addon: 'TeamSports'
    },

    props: {
        link: {
            title: 'Page with competition list',
            type: String,
            fulltype: 'page'
        }
    },

    components: {
        CardLayout,
        CategoryCard,
        ZoeziAutocomplete,
    },

    data() {
        return {
            search: null,
            searchText: null,
            teamsports: [],
            loading: false
        }
    },
    computed: {
        filteredTeamsports() {
            return this.teamsports
                .filter(item =>
                    item.visibleForCustomer && (!this.searchText || item.name.toLowerCase().includes(this.searchText.toLowerCase()))
                )
                .sort((a, b) => a.name.localeCompare(b.name));
        },
        imageUrl() {
            return this.$api.getImageUrl('/assets/img/teamsport.jpg')
        },
        searchLabel() {
            return this.$translate('Search team sport')
        }
    },
    methods: {
        getTeamsports() {
            this.loading = true;
            this.$api.get('/api/teamsport/get').then(teamsports => {
                this.teamsports = teamsports;
                this.loading = false;
            });
        },
        gotoCompetitionList(category) {
            this.$root.followLink(this.link, category.id)
        }
    },
    mounted() {
        this.getTeamsports()
        this.unsubscribe = this.$root.$api.subscribe({type: 'teamsport', callback: () => this.getTeamsports() });
    },
    unmounted() {
        this.unsubscribe?.();
    }
}
</script>

<style scoped>
.title {
    position:relative;
    z-index: 100;

    @media (max-width: 550px) {
        font-size: 0.7em;
    };
    @media (max-width: 300px) {
        font-size: 0.5em;
    };
}
</style>
